import Tippy from "@tippyjs/react"

export const SpeedApprovalTooltip = ({canViewJobControl = false}) => {
    return(
        <Tippy
            content={
                <div className="text-sm text-left max-w-sm z-50">
                    <p >This table shows past and pending speed approvals that you have permission to approve.</p>
                    {canViewJobControl && <p className="mt-2">Users that can approve speed notifications are set in the Job Control → Speed Notifications tab.</p>}
                </div>
            }
            interactive
            delay={[200, 0]}
            placement="bottom"
        >
            <i
                className="fa-solid fa-circle-question text-violet-800 cursor-help text-sm"
                aria-label="What speed approvals can I view?"
            />
        </Tippy>
    )
}